/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';

/**
 * FetchcompleteYourBedData Input Action
 */
export class FetchCompleteYourBedDataInput implements Msdyn365.IActionInput {
    public jsonData: string;
    // Construct the input needed to run the action
    constructor(jsonData: string) {
        this.jsonData = jsonData;
    }

    // Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `completeYourBedData`;
    public getCacheObjectType = () => 'completeYourBedDataObject';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// Create a data model here or import one to capture the response of the action
export interface IFetchcompleteYourBedData {
    text: string;
    jsonData: string;
}

export interface IDataRow {
    mattressVariantReqId: string;
    buyAllVariantRecIds:any;
}

export interface foo {
    data: AsyncResult<IDataRow[]>;
}

/**
 * Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext<IFetchcompleteYourBedData>): Msdyn365.IActionInput => {
    return new FetchCompleteYourBedDataInput(args?.config?.jsonData!);
};

/**
 * Use this function to call your action and process the results as needed
 */
async function action(input: FetchCompleteYourBedDataInput, ctx: Msdyn365.IActionContext): Promise<IDataRow> {

    const res = await Msdyn365.sendRequest<any>(input.jsonData, 'get');
    const data = res.data;
    return data;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IDataRow>>action,
    // Give your data action a unique id
    id: 'FetchcompleteYourBedData',
    input: createInput
    // Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
